import { createContext } from 'react';

import { GetTutorialQuery_me_tutorial } from 'graphql/types';

import { useStartTutorial } from '../../useStartTutorial';

interface StartTrainingContextType {
  startingTutorial: boolean;
  creatingTutorial: boolean;
  unfinishedTutorial?: GetTutorialQuery_me_tutorial;
  continueTutorial?: () => void;
  restartTutorial?: () => void;
  handleStartTutorial?: () => Promise<void>;
  closeUnfinishedTutorialDialog?: () => void;
}

export const StartTrainingContext = createContext<StartTrainingContextType>({
  startingTutorial: false,
  creatingTutorial: false,
});

interface Props {
  children: React.ReactNode | null;
}

export const StartTrainingProvider = ({ children }: Props) => {
  const {
    startingTutorial,
    creatingTutorial,
    handleStartTutorial,
    unfinishedTutorial,
    continueTutorial,
    restartTutorial,
    closeUnfinishedTutorialDialog,
  } = useStartTutorial();

  return (
    <StartTrainingContext.Provider
      value={{
        startingTutorial,
        creatingTutorial,
        handleStartTutorial,
        unfinishedTutorial,
        continueTutorial,
        restartTutorial,
        closeUnfinishedTutorialDialog,
      }}
    >
      {children}
    </StartTrainingContext.Provider>
  );
};
